export default "__VITE_ASSET__MRsmdW2Q__"